/**
 * Snippet: Slider Images
 * ------------------------------------------------------------------------------
 * Used in section-slider-images.liquid
 *
 * @namespace sliderImages
 */

import Swiper from 'swiper'
import { Pagination, Navigation, Autoplay } from 'swiper/modules'
import 'swiper/css'

class SliderImages extends HTMLElement {
  constructor() {
    super()
  }
  connectedCallback() {
    const prev = this.closest('.section-slider-images').querySelector(
      '.slider__prev'
    )
    const next = this.closest('.section-slider-images').querySelector(
      '.slider__next'
    )

    const slidesCount = this.getAttribute('data-slides-count')

    const swiper = new Swiper(this, {
      // Optional parameters
      slidesPerView: 2,
      spaceBetween: 10,
      modules: [Pagination, Navigation],
      navigation: {
        nextEl: next,
        prevEl: prev,
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
        },
        1200: {
          slidesPerView: 4,
        },
      },
    })
  }
}
customElements.define('slider-images', SliderImages)
